// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webcam-preview-container {
  max-width: 320px;
  border: 1px solid var(--border-color);
  border-radius: var(--dialog-border-radius);
  font-size: 0;
}

.webcam-preview-container video {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: auto;
  border-radius: calc(var(--dialog-border-radius) - 1px);
  transform: rotateY(180deg);
}

.webcam-preview-container-blurred {
  max-width: 320px;
  border: 1px solid var(--border-color);
  border-radius: var(--dialog-border-radius);
  font-size: 0;
}

.webcam-preview-container-blurred canvas {
  display: block;
  width: 100%;
  height: auto;
  border-radius: calc(var(--dialog-border-radius) - 1px);
  transform: rotateY(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/webcam-preview/WebcamPreview.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sDAAsD;EACtD,0BAA0B;AAC5B","sourcesContent":[".webcam-preview-container {\n  max-width: 320px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--dialog-border-radius);\n  font-size: 0;\n}\n\n.webcam-preview-container video {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: auto;\n  border-radius: calc(var(--dialog-border-radius) - 1px);\n  transform: rotateY(180deg);\n}\n\n.webcam-preview-container-blurred {\n  max-width: 320px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--dialog-border-radius);\n  font-size: 0;\n}\n\n.webcam-preview-container-blurred canvas {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: calc(var(--dialog-border-radius) - 1px);\n  transform: rotateY(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
